import api from './api';

export interface BackfillResult {
  flagged: {
    wines:     number;
    producers: number;
    regions:   number;
    grapes:    number;
    wineNames: number;
    total:     number;
  };
}

export interface FixIndexResult {
  droppedOldIndex: boolean;
  message: string;
}

const migrateService = {
  backfillNeedsReview: async (): Promise<BackfillResult> => {
    const response = await api.post('/admin/governance/migrate/backfill-needs-review');
    return response.data;
  },

  fixInventoryItemIndex: async (): Promise<FixIndexResult> => {
    const response = await api.post('/admin/governance/migrate/fix-inventory-item-index');
    return response.data;
  },

  fixWineListItemIndex: async (): Promise<FixIndexResult> => {
    const response = await api.post('/admin/governance/migrate/fix-wine-list-item-index');
    return response.data;
  },
};

export default migrateService;
